import { boolean, string, struct } from 'io-ts/Decoder';

import { RefItem as UserRefItem } from '../user/RefItem';

import { Category } from './Category';
import { Type as MetadataType } from './metadata/Type';

export const Type = struct({
	id: string,

	title: string,
	subtitle: string,
	details: string,
	persistent: boolean,
	toast: boolean,

	metadata: MetadataType,

	category: Category,

	createdAt: string,
	createdBy: UserRefItem,
});
